export function emptyOrUndefinedArray<T>(value: Array<T> | undefined | null): boolean {
	return value === undefined || value === null || !Array.isArray(value) || value.length === 0;
}
